import moment from "moment";

export const REQUEST_ASSIGN_TASK = "REQUEST_ASSIGN_TASK";
export const REQUEST_ASSIGNMENTS_SUCCEEDED = "REQUEST_ASSIGNMENTS_SUCCEEDED";
export const REQUEST_ASSIGNMENTS_FAILED = "REQUEST_ASSIGNMENTS_FAILED";
export const UPDATE_ASSIGNMENT = "UPDATE_ASSIGNMENT";
export const SHOW_ASSIGNMENT_OVERLAPS = "SHOW_ASSIGNMENT_OVERLAPS";
export const CLEAR_ASSIGNMENT_OVERLAPS = "CLEAR_ASSIGNMENT_OVERLAPS";

export const assignmentFromTask = (task) => ({
    resourceAssignedTo: task.resourceAssignedTo,
    workOrderNumber: task.workOrderNumber,
    //taskAssignedDate: task.taskAssignedDate,
    scheduledDate: task.scheduledDate,
    duration: task.duration,
    status: task.status,
});

// Take the task data.  Filter out the unassigned tasks.  Keep the
// fields we need to populate the gantt
// TODO: Perhaps we need to break this into tasks by day?
export const requestAssignmentsSucceeded = (assignments) => {
    return {
        type: REQUEST_ASSIGNMENTS_SUCCEEDED,
        assignments: assignments.filter((task) => task.resourceAssignedTo != null).map(assignmentFromTask),
    };
};

export const requestAssignmentsFailed = () => {
    return {
        type: REQUEST_ASSIGNMENTS_FAILED,
    };
};

// Action to request an assignment
// need to keep track of assignment, WO, and Tech so we can show overlaps
export const requestAssignTask = (workOrder, technician, assignment, overrideWarning, isUnassigned) => {
    return {
        type: REQUEST_ASSIGN_TASK,
        assignTaskRequest: {
            workOrder,
            technician,
            assignment,
            overrideWarning,
            isUnassigned,
        },
    };
};

export const updateAssignment = (assignment) => {
    return {
        type: UPDATE_ASSIGNMENT,
        assignment,
    };
};

export const showAssignmentOverlaps = (overlaps) => {
    return {
        type: SHOW_ASSIGNMENT_OVERLAPS,
        overlaps: overlaps.map((overlap) => ({
            ...overlap,
            //taskAssignedDate: moment(Date.parse(overlap.taskAssignedDate.slice(0, 19))),
            scheduledDate: moment(Date.parse(overlap.scheduledDate.slice(0, 19))),
        })),
    };
};

export const clearAssignmentOverlaps = () => {
    return {
        type: CLEAR_ASSIGNMENT_OVERLAPS,
    };
};
